import {
  ClockIcon,
  SentBackIcon,
  SkippedIcon,
  OnHoldIcon,
  TickIcon
} from "@/features/common/Icons";
import { Step } from "../ReviewsInProgress";
import {
  isStepsLessThanEqualToEdgeCase,
  isStepsMoreThanEdgeCase
} from "./WorkflowTaskProgress";
import {
  IN_PROGRESS_STATUS,
  NOT_STARTED_STATUS,
  ON_HOLD_STATUS,
  SENT_BACK_STATUS,
  SKIPPED_STATUS,
  SUBMITTED_STATUS
} from "@/features/common/constants";
interface WorkflowTaskStep {
  step: Step;
  allExpanded: boolean;
  openTooltip: (event: React.MouseEvent<HTMLElement>, step: number) => void;
  clickedStep: number;
  expandStepOnClick: (step: number) => void;
  stepsLength: number;
}

export function stepClass(state: string) {
  switch (state) {
    case IN_PROGRESS_STATUS:
      return "step-in-progress";
    case NOT_STARTED_STATUS:
      return "step-not-started";
    case SUBMITTED_STATUS:
      return "step-submitted";
    case SENT_BACK_STATUS:
      return "step-sent-back";
    case SKIPPED_STATUS:
      return "step-skipped";
    case ON_HOLD_STATUS:
      return "step-on-hold";
    default:
      return "";
  }
}

export function WorkflowTaskStep({
  step,
  allExpanded,
  openTooltip,
  clickedStep,
  expandStepOnClick,
  stepsLength
}: WorkflowTaskStep) {
  let showFullNameOnClick: boolean = clickedStep === step.stepIndex;

  function stepClassTooltip() {
    return showFullNameOnClick ? "full-width" : "";
  }

  function showInProgressStepName() {
    return showFullNameOnClick || clickedStep === -1;
  }

  function expandedWithName() {
    return showInProgressStepName() && step.state === IN_PROGRESS_STATUS
      ? "show-expanded"
      : "";
  }

  function edgesClass() {
    if (step.stepIndex === 0) {
      return "first-step";
    } else if (stepsLength - 1 === step.stepIndex) {
      return "last-step";
    } else return "";
  }
  function edgeCaseSteps() {
    return isStepsMoreThanEdgeCase(stepsLength) ? "edge-case" : "";
  }

  function handleClickStep(
    event: React.MouseEvent<HTMLElement>,
    stepIndex: number
  ) {
    const stepElement = document.querySelector(
      '.step[tabIndex="0"]'
    ) as HTMLElement;
    if (stepElement) {
      stepElement.tabIndex = -1;
    }
    expandStepOnClick(stepIndex);
    openTooltip(event, stepIndex);
  }
  return (
    <div
      className={
        allExpanded
          ? `step tabbing ${stepClass(step.state)} hover  ${edgesClass()}`
          : `step tabbing ${edgesClass()} ${stepClass(
              step.state
            )} ${stepClassTooltip()} ${expandedWithName()}  hover ${edgeCaseSteps()}`
      }
      onClick={(event) => {
        if (isStepsLessThanEqualToEdgeCase(stepsLength)) {
          handleClickStep(event, step.stepIndex);
        } else {
          event.preventDefault();
        }
      }}
    >
      {allExpanded ? (
        <div className="flex-row in-progress-content">
          {step.state !== NOT_STARTED_STATUS && (
            <div className="clock-icon">
              {step.state === IN_PROGRESS_STATUS && <ClockIcon />}
              {step.state === SUBMITTED_STATUS && <TickIcon />}
              {step.state === SENT_BACK_STATUS && (
                <div className="sent-back">
                  <SentBackIcon />
                </div>
              )}
              {step.state === SKIPPED_STATUS && (
                <div className="skipped">
                  <SkippedIcon />
                </div>
              )}
              {step.state === ON_HOLD_STATUS && (
                <div className="on-hold">
                  <OnHoldIcon />
                </div>
              )}
            </div>
          )}
          <div className="step-name step-name-expanded">{step.name}</div>
        </div>
      ) : (
        <div className="step-content">
          {step.state === IN_PROGRESS_STATUS && (
            <div className="flex-row in-progress-content">
              <div className="clock-icon">
                <ClockIcon />
              </div>
              {showInProgressStepName() && (
                <div className="step-name">{step.name}</div>
              )}
            </div>
          )}

          {step.state === SUBMITTED_STATUS && (
            <div className="flex-row in-progress-content">
              {(isStepsLessThanEqualToEdgeCase(stepsLength) ||
                showFullNameOnClick) && (
                <div className="clock-icon">
                  <TickIcon />
                </div>
              )}
              {showFullNameOnClick && (
                <div className="step-name">{step.name}</div>
              )}
            </div>
          )}
          {step.state === SENT_BACK_STATUS && (
            <div className="flex-row in-progress-content">
              {(isStepsLessThanEqualToEdgeCase(stepsLength) ||
                showFullNameOnClick) && (
                <div className="sent-back-icon">
                  <SentBackIcon />
                </div>
              )}
              {showFullNameOnClick && (
                <div className="step-name">{step.name}</div>
              )}
            </div>
          )}
          {step.state === SKIPPED_STATUS && (
            <div className="flex-row in-progress-content">
              {(isStepsLessThanEqualToEdgeCase(stepsLength) ||
                showFullNameOnClick) && (
                <div className="sent-back-icon">
                  <SkippedIcon />
                </div>
              )}
              {showFullNameOnClick && (
                <div className="step-name">{step.name}</div>
              )}
            </div>
          )}
          {step.state === ON_HOLD_STATUS && (
            <div className="flex-row in-progress-content">
              {(isStepsLessThanEqualToEdgeCase(stepsLength) ||
                showFullNameOnClick) && (
                <div className="sent-back-icon">
                  <OnHoldIcon />
                </div>
              )}
              {showFullNameOnClick && (
                <div className="step-name">{step.name}</div>
              )}
            </div>
          )}
          {step.state === NOT_STARTED_STATUS &&
            (showFullNameOnClick ? (
              <div className="step-name">{step.name}</div>
            ) : (
              isStepsLessThanEqualToEdgeCase(stepsLength) && step.stepIndex + 1
            ))}
        </div>
      )}
    </div>
  );
}
